<div class="container-fluid p-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div class="d-flex align-items-center gap-4">
      <div>
        <h1 class="mb-0">Remittance Configuration - {{ countryDetails.displayName }}</h1>
        <p class="text-muted">Manage remittance allowed countries configuration for {{ countryDetails.displayName }}</p>
      </div>
      @if (countryDetails.logo) {
        <div class="d-flex align-items-center">
          <img [src]="countryDetails.icon" class="img-fluid" style="height: 40px; object-fit: contain;" alt="{{ countryDetails.displayName }} logo">
        </div>
      }
    </div>
    <button class="btn btn-sm btn-light" (click)="goBack()">
      <i class="bi bi-arrow-left me-2"></i>Back to Countries
    </button>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">Remittance Configuration</h5>
          </div>
        </div>
        <div class="card-body">
          <!-- Loading State -->
          @if (loading) {
            <div class="d-flex justify-content-center align-items-center py-5">
              <div class="text-center">
                <div class="spinner-border text-primary mb-3" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
                <p class="text-muted">Loading configuration...</p>
              </div>
            </div>
          }

          @if (successMessage) {
            <div class="alert alert-success">{{ successMessage }}</div>
          }
          @if (errorMessage) {
            <div class="alert alert-danger">{{ errorMessage }}</div>
          }
          @if (!loading) {
            <div>
              <form #remittanceForm="ngForm" (ngSubmit)="saveRemittanceConfig()">
                <div class="mb-4">
                  <div class="form-check form-switch">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      id="allowRemittanceFromAll"
                      [(ngModel)]="remittanceConfig.allowRemittanceFromAll"
                      name="allowRemittanceFromAll"
                      (change)="onAllowAllChange()"
                      >
                    <label class="form-check-label" for="allowRemittanceFromAll">
                      Allow remittance from all countries
                    </label>
                  </div>
                </div>
                @if (!remittanceConfig.allowRemittanceFromAll) {
                  <div class="mb-4">
                    <label class="form-label">Allowed Remittance Countries</label>
                    <div class="row">
                      <div class="col-md-6">
                        <select
                          class="form-select"
                          [(ngModel)]="selectedCountryId"
                          name="selectedCountryId"
                          size="8"
                          style="height: 300px;"
                          >
                          @for (country of availableCountries; track country) {
                            <option
                              [value]="country._id"
                              [disabled]="isCountrySelected(country._id)"
                              >
                              {{ country.displayName }} ({{ country.country_code }})
                            </option>
                          }
                        </select>
                      </div>
                      <div class="col-md-1 d-flex flex-column justify-center align-items-center gap-2">
                        <button
                          type="button"
                          class="btn btn-sm btn-primary"
                          (click)="addCountry()"
                          [disabled]="!selectedCountryId"
                          >
                          <i class="bi bi-arrow-right"></i>
                        </button>
                        <button
                          type="button"
                          class="btn btn-sm btn-danger"
                          (click)="removeCountry()"
                          [disabled]="!selectedAllowedCountryId"
                          >
                          <i class="bi bi-arrow-left"></i>
                        </button>
                      </div>
                      <div class="col-md-5">
                        <select
                          class="form-select"
                          [(ngModel)]="selectedAllowedCountryId"
                          name="selectedAllowedCountryId"
                          size="8"
                          style="height: 300px;"
                          >
                          @for (country of allowedCountries; track country) {
                            <option
                              [value]="country._id"
                              >
                              {{ country.displayName }} ({{ country.country_code }})
                            </option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                }
                <div class="d-flex gap-2">
                  <button type="submit" class="btn btn-primary" [disabled]="loading">
                    <i class="bi bi-save me-2"></i>Save Changes
                  </button>
                  <button type="button" class="btn btn-light" (click)="resetForm()">
                    <i class="bi bi-arrow-clockwise me-2"></i>Reset
                  </button>
                </div>
              </form>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
